import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

const TodoCard = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 16px 12px 16px;
  border-radius: 6px;
  border: 1px solid var(--soremo-border);
  background-color: #fff;
  box-shadow: 2px 4px 8px 0px rgba(0, 0, 0, 0.05);
`;

interface TodoCardWrapperProps {
  children: React.ReactNode;
  fadingOut?: boolean;
  onMouseMove?: (e: React.MouseEvent) => void;
}

const TodoCardWrapper: React.FC<TodoCardWrapperProps> = ({ children, fadingOut = false, onMouseMove }) => {
  const { isMobile } = useSelector((state: any) => state.device);

  return (
    <TodoCard
      className={fadingOut ? "fade-out-bck" : undefined}
      style={fadingOut ? { pointerEvents: "none" } : undefined}
      onMouseMove={!isMobile ? onMouseMove : undefined}
    >
      {children}
    </TodoCard>
  );
};

export default TodoCardWrapper;

